import api from '../api'

export default {
  namespaced: true,
  state: {
    moduleList: []
  },
  mutations: {
    SET_MODULE_LIST (state, data) {
      state.moduleList = data
    }
  },
  actions: {
    GET_MODULE_LIST ({ commit, dispatch }) {
      return api.getModules().then((res) => {
        commit('SET_MODULE_LIST', res.payload)
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    SAVE_MODULE ({ commit, dispatch }, data) {
      return api.saveModule({ data }).then((res) => {
        window.myVue.$message.success('保存成功')
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    DELETE_MODULE ({ commit, dispatch }, id) {
      let query = { id }

      return api.deleteModule({ query }).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    BATCH_DELETE_MODULE ({ commit, dispatch }, ids) {
      let data = { moduleId: ids }

      return api.batchDeleteModule({ data }).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/setting/store/index.js